import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { Avatar } from '../../../Avatar'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { FloatingTooltip } from '../../../Floating'
import { ICON_HEIGHT_24 } from '../../../Icon'
import Text from '../../../Text'
import { QA_NAME_PROFILE_USER_INFO_CONTACT_COPY_BUTTON } from '../ProfileUserInfoItemCard.constants'

import * as styles from './ProfileUserInfoItemCardContactRowContent.module.css'

import CopyIcon from '../../../../icons/copy.svg'

function ProfileUserInfoItemCardContactRowContent({
  ContactIcon,
  contact,
  contactValueRef,
  copied,
  copyTooltip,
  isCopyableContact,
  ref,
  valueTooltip,
  onCopy,
}) {
  return (
    <div
      className={classNames(styles.contactRow, {
        [styles.contactRowCopyable]: isCopyableContact,
      })}
      ref={ref}
      role={isCopyableContact ? 'button' : undefined}
      tabIndex={isCopyableContact ? 0 : undefined}
      onClick={onCopy}
    >
      <div className={styles.contactRowIcon}>
        <Avatar Icon={ContactIcon} size={ICON_HEIGHT_24} />
      </div>
      <div className={styles.contactText}>
        <FloatingTooltip
          content={valueTooltip}
          disabled={!valueTooltip}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text
            isSecondary
            className={styles.contactValue}
            ref={contactValueRef}
          >
            {contact.value}
          </Text>
        </FloatingTooltip>
        <Text className={styles.contactLabel}>{contact.label}</Text>
      </div>
      {isCopyableContact ? (
        <div className={styles.contactCopyWrap}>
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: CopyIcon }}
            className={styles.contactCopyButton}
            disabled={copied}
            height={BUTTON_HEIGHT_32}
            qaName={QA_NAME_PROFILE_USER_INFO_CONTACT_COPY_BUTTON}
            tooltip={copyTooltip}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            onClick={onCopy}
          />
        </div>
      ) : null}
    </div>
  )
}

export default ProfileUserInfoItemCardContactRowContent
